import type {
  AnyShapeData,
  InteractionPointData,
} from '@deepguide-ai/react-image-editor'
import { atom } from 'jotai'

// 编辑器打开/关闭状态
export const isImageEditorOpenAtom = atom<boolean>(false)

export interface ImageEditorData {
  src: string
  initialInteractionPoints?: InteractionPointData[]
  initialAnnotations?: AnyShapeData[]
  stepId?: string
}

// 默认数据（空态；打开编辑器前由 saveImageEditorData 写入真实 src）
export const defaultImageEditorData: ImageEditorData = {
  src: '',
}

// 使用atom管理imageEditorData
export const imageEditorDataAtom = atom<ImageEditorData>(defaultImageEditorData)

// 获取数据的方法 - 修复为只读atom
export const getImageEditorDataAtom = atom((get) => get(imageEditorDataAtom))

// 保存数据的方法
export const saveImageEditorDataAtom = atom(
  null,
  (_get, set, data: ImageEditorData) => {
    set(imageEditorDataAtom, data)
  }
)

// 更新部分数据的方法
export const updateImageEditorDataAtom = atom(
  null,
  (_get, set, updates: Partial<ImageEditorData>) => {
    set(imageEditorDataAtom, (prev) => ({
      ...prev,
      ...updates,
    }))
  }
)

// 重置数据
export const resetImageEditorDataAtom = atom(null, (_get, set) => {
  set(imageEditorDataAtom, defaultImageEditorData)
})

// 按 stepId 存储已编辑截图的信息，包括 URL 和 viewportCoordinates
export interface EditedScreenshotData {
  sourceUrl: string
  url: string
  viewportCoordinates?: {
    topLeft: { x: number; y: number }
    topRight: { x: number; y: number }
    bottomLeft: { x: number; y: number }
    bottomRight: { x: number; y: number }
    center: { x: number; y: number }
    width: number
    height: number
  }
}

export const editedScreenshotMapAtom = atom<
  Record<string, EditedScreenshotData>
>({})
